import { ColorOptions, Icon, ModBox, Spacer, Text } from '@jfs/ui-new'
import React from 'react'
import { useStores } from '../../../../data/store'
import { List } from '../../../ApiOnboarding/List'

const EmApiOnboarding = ({ showSuccess }: any) => {
  const { listData } = useStores((store) => ({
    listData: store.onboarding.getEmApiOnboardedData(),
  }))

  console.log('listData::', listData)

  return (
    <ModBox show={showSuccess} f={1} justify={'center'} align={'center'} ph={80} pv={24}>
      <Icon id={'SUCCESSFUL_FILLED'} color={'#00840F' as ColorOptions} size={64} />
      <Spacer size={24} direction={'vertical'} />
      <Text
        title={'API onboarding is done.\nPlease proceed for the next steps.'}
        color={'BLACK_21'}
        fontSize={18}
        fontFamily={'jiotype-bold'}
        textAlign={'center'}
      />
      <Spacer size={24} direction={'vertical'} />
      <Text
        title={'In the next steps, you can view and edit API Configuration.'}
        color={'PRIMARY_GREY'}
        fontSize={14}
        fontFamily={'jiotype-medium'}
        textAlign={'center'}
      />
      <Spacer size={24} direction={'vertical'} />
      <List data={listData} />
    </ModBox>
  )
}

export default EmApiOnboarding
